export default __webpack_public_path__ + "static/media/11.b4b9594a.jpg";